export default {
  "secondary": "_secondary_1weam_1",
  "buttonBar": "_buttonBar_1weam_11",
  "destructive": "_destructive_1weam_21"
};import "ni:sha-256;430zTedro9vY9LBWPyRUwsDDZK1vDjLA3e0_KkGpvuk";